import { Injectable } from '@angular/core';
import { CanActivate, Router, CanLoad, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';

import { take, map } from 'rxjs/operators';

import { JwtAuthenticationService } from './jwt-authentication.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private readonly router: Router, private readonly userService: JwtAuthenticationService) {}

  public canActivate(): Observable<boolean> {
    return this.checkAuth();
  }

  public canLoad(): Observable<boolean> {
    return this.checkAuth();
  }

  public canActivateChild(): Observable<boolean> {
    return this.checkAuth();
  }

  private checkAuth(): Observable<boolean> {
    console.log('Authentication check');
    return this.userService.isAuthenticated.pipe(take(1)).pipe(
      map((authenticated) => {
        console.log(`Authenticated: ${!!authenticated}`);
        if (!authenticated) {
          this.router.navigate(['/auth/login']);
        }
        return !!authenticated;
      })
    );
  }
}
